import React from 'react'

export default function splash() {
  document.title = "Byokeh Studio";
  return (
	<>
	<div className="splash">
      <p className="splash-text">Byokeh Studio</p>
    </div>
	</>
  )
}
